/* eslint-disable */
var animating; //flag to prevent quick multi-click glitches

function initheight() {
    vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

let $menuItems = $('.to-animate');



window.InitAnimation = function(items, delay = 60) {
    $menuItems = items;
    $('footer').addClass('show');
    let time = 10;
    $menuItems.each(function(i) {
        setTimeout(function() {
            $menuItems.eq(i).addClass('show');
            // $(this).addClass('lol');
        }, time)
        time += delay;
    });

    setTimeout(function() {
        $('.footer>*').addClass('show')
    }, 100)

}

initheight();
InitAnimation($menuItems, 150);
$(window).resize(function() {
    initheight();

});


$('.go-confirm-discount').click(function() {

    $('.select-step').addClass('hideMain');
    $('.return-main').addClass('show');

    $('.activate-discount .first-step form').show()
    $('.activate-discount .success_msg,.activate-discount .error_msg ,.activate-discount .second-step').addClass('d-none').removeClass('d-flex d-block');

    $('.activate-discount form').each(function() {
        this.reset();
        $(this).find('.messages').html('');
        $(this).find('.form-group').removeClass('has-success has-error');
    });

    $('.activate-discount').find('.form-wrapper .animateme').removeClass('show');
    $('.activate-discount').find('.confirm-submit').removeClass('active').addClass('d-none');
    $('.activate-discount').find('form').find('.form-wrapper').removeClass('d-none');


    $('.activate-discount .show').removeClass('show');
    $('.activate-discount ,.activate-discount .first-step').removeClass('d-none');
    let $disount = $('.activate-discount .to-animate');

    InitAnimation($disount, 150);
})

$('.go-follow-discounts').click(function() {

    $('.select-step').addClass('hideMain');
    $('.return-main').addClass('show');
    $('.follow-discounts-form').show()
    $('.follow-discounts .success_msg,.follow-discounts .error_msg,.follow-discounts .form_loader_1').addClass('d-none').removeClass('d-flex d-block');
    $('.follow-discounts .show').removeClass('show');
    $('.follow-discounts').removeClass('d-none');
    $('.follow-discounts form').each(function() {
        this.reset();
        $(this).find('.messages').html('');
        $(this).find('.form-group').removeClass('has-success has-error');
    });

    let $disount = $('.follow-discounts .to-animate');
    InitAnimation($disount, 150);
})
$('.return-main').click(function() {
    let that = $(this);

    $(this).removeClass('show');
    $('.form-steps').removeClass('lg-wraaper');

    $('.follow-discounts .show ,.activate-discount .show').removeClass('show');
    $('.follow-discounts ,.activate-discount').addClass('d-none');

    $('.select-step .show').removeClass('show');

    let $mainbtns = $('.select-step .to-animate');
    InitAnimation($mainbtns, 200);
    $('.select-step').removeClass('hideMain');
    //
    // var next = $(this).attr('data-next-step');
    // $(current).addClass('d-none');
    // $('.' + next).removeClass('d-none');
    // window.InitAnimation($('.' + next).find('.form-wrapper .animateme'));

    // $('current').find('.msg').addClass('d-none').removeClass('d-block d-flex');

    //

})
if ($('.selectpickerCustom').length > 0) {
    $('.selectpickerCustom').selectpicker();

    if ((/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) && $('.selectpickerCustom').hasClass('mob-selectpicker')) {
        $('.selectpickerCustom').selectpicker('mobile');
    }
}

function loadData(url) {
    $('.discounts-data .form_loader_1').removeClass('d-none');

    $.getJSON(url, function(data) {

        if (typeof data === 'object') {
            $('.discounts-data .n-msg').html(data.data);
            let $animatedRows = $('.discounts-data .n-msg .animateme');
            $('.discounts-data .form_loader_1').addClass('d-none');

            InitAnimation($animatedRows, 150);

        }
    })
}
$('.selectpickerCustom').on('changed.bs.select', function(e, clickedIndex, isSelected, previousValue) {
    let val = e.target.value;
    let that = $(this);
    var selectUrl = $(that).find('option:selected').attr('data-url');
    if ($(that).hasClass('monthDepend')) {

        let selectedMonth = $('.monthSelect').find("option:selected").val();
        selectUrl = selectUrl + '&month=' + selectedMonth;
        //monthSelect
    } else {
        if ($(that).hasClass('yearDepend')) {

            let selectedYear = $('.yearSelect').find("option:selected").val();
            selectUrl = selectUrl + '&year=' + selectedYear;
            //monthSelect
        }
    }
    loadData(selectUrl)

})
$(".nexttostep").click(function() {
    let that = $(this);
    if ($(this).attr('data-next-step')) {
        var current = $(this).closest('.form-step');
        var next = $(this).attr('data-next-step');
        $(current).addClass('d-none');
        $('.' + next).removeClass('d-none');
        window.InitAnimation($('.' + next).find('.form-wrapper .animateme'));

        $('current').find('.msg').addClass('d-none').removeClass('d-block d-flex');


        if (that.hasClass('showform')) {
            if (that.hasClass('no-to-reset')) {

            } else {
                $('.form-steps form').each(function() {
                    this.reset();
                    $(this).find('.messages').html('');
                    $(this).find('.form-group').removeClass('has-success has-error');

                });
            }
            $('.form-steps').find('.animateme').removeClass('show');
            $('.form-steps').find('form').show();
            $('.form-steps').find('.msg').addClass('d-none').removeClass('d-block d-flex');
            $('.form-steps').find('.form-wrapper').removeClass('d-none');
            $('.form-steps').find('.confirm-submit').removeClass('active').addClass('d-none');

            $('.form-steps form').find('.success_msg.msg').removeClass('d-block d-flex').addClass('d-none');
            $('.form-steps form').removeClass('d-none').addClass('show');

            window.InitAnimation($('.' + next).find('.to-animate'));
        }

    }

})

$(".back-to-change").click(function() {
    $(this).parent().parent().closest('form').find('.form-wrapper .animateme').removeClass('show');
    $(this).closest('.confirm-submit').removeClass('active').addClass('d-none');
    $(this).parent().parent().closest('form').find('.form-wrapper').removeClass('d-none');
    window.InitAnimation($(this).parent().parent().closest('form').find('.form-wrapper .animateme'));



})